import { render } from "./PresentationWindow.vue?vue&type=template&id=36f6fd16&scoped=true"
import script from "./PresentationWindow.vue?vue&type=script&lang=js"
export * from "./PresentationWindow.vue?vue&type=script&lang=js"

import "./PresentationWindow.vue?vue&type=style&index=0&id=36f6fd16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f6fd16"]])

export default __exports__